import { render, staticRenderFns } from "./TableOfResults.vue?vue&type=template&id=291556bb&"
import script from "./TableOfResults.vue?vue&type=script&lang=js&"
export * from "./TableOfResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports